<template>
    <CalendarCellTrigger
        :class="
            cn(
                'ds-calendar-cell-trigger h-8 w-8 rounded-full p-0 font-normal',
                // Hover
                ':hover:border-ds-primary-900',
                // Selected
                'data-[selected]:opacity-100',
                // Focus
                'outline-none focus-within:bg-ds-primary-100',
                // Disabled
                'data-[disabled]:text-ds-primary-500 data-[disabled]:opacity-50',
                // Unavailable
                'data-[unavailable]:text-ds-primary-50 data-[unavailable]:line-through',
                // Outside months
                'data-[outside-view]:text-ds-primary-500 data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:bg-ds-primary-100/50 [&[data-outside-view][data-selected]]:text-ds-primary-500 [&[data-outside-view][data-selected]]:opacity-30',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <button
            class="h-8 w-8 rounded-full p-0 font-normal focus:outline-none"
            size="sm"
            variant="tertiary"
        >
            {{ props.day.day }}
        </button>
    </CalendarCellTrigger>
</template>

<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarCellTriggerProps } from 'reka-ui';
import { CalendarCellTrigger, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<style scoped lang="scss">
.ds-calendar-cell-trigger {
    @apply text-sm text-content-primary;
    button:active {
        @apply border border-ds-primary-900;
    }
    button:focus {
        @apply bg-ds-primary-100;
    }
    &:hover {
        @apply border-ds-primary-900 bg-ds-primary-100;
    }
    &[data-selected] {
        button {
            @apply border border-ds-primary-900 bg-ds-primary-900 text-content-inverse;
        }
    }
    &[data-today]:not([data-selected]) {
        button {
            @apply border border-semantic-primary-default;
        }
    }
}
</style>
